import { useStore } from "zustand";

import { sharedStore } from "../store/sharedStore";

/**
 * Pinned sites, backed by the shared, persisted {@link sharedStore}. Pins are
 * global across every app on the same origin (capped at `MAX_PINS`) and stay in
 * sync across tabs.
 */
export function usePinnedSites() {
  const pinned = useStore(sharedStore, (state) => state.pinnedSites);
  const { togglePin } = sharedStore.getState();

  return { pinned, togglePin };
}
